"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var introspectionQueryResultData = require("@tableau/data-catalog-api-schema/dist/fragments.json");
var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
var apollo_client_1 = require("apollo-client");
var apollo_link_context_1 = require("apollo-link-context");
var apollo_link_http_1 = require("apollo-link-http");
// Using the 'require' syntax because we need to use the 'main' (not 'module') form of unfetch, as
// only the 'main' form is interpreted as a function.
var unfetch = require("unfetch/dist/unfetch.js");
var CookieHelpers_1 = require("./utils/CookieHelpers");
var DEFAULT_LINK_OPTIONS = {
    uri: '/api/exp/metadata/graphql',
    credentials: 'same-origin',
    fetch: unfetch,
};
var XSRF_COOKIE_NAME = 'XSRF-TOKEN';
var XSRF_PROTECTION_HEADER_NAME = 'X-XSRF-TOKEN';
// Cache is disabled because of TFS 882415.
var useApolloCache = false;
exports.queryOptions = {
    fetchPolicy: useApolloCache ? 'cache-first' : 'no-cache',
    errorPolicy: 'all',
};
function getXSRFHeaderLink(xsrfToken) {
    var XSRFHeaderLink = apollo_link_context_1.setContext(function (_, _a) {
        var headers = _a.headers;
        var token = xsrfToken || CookieHelpers_1.getCookieValue(window.document.cookie, XSRF_COOKIE_NAME);
        var newHeaders = __assign({}, headers);
        if (token) {
            newHeaders[XSRF_PROTECTION_HEADER_NAME] = token;
        }
        return {
            headers: newHeaders
        };
    });
    return XSRFHeaderLink;
}
/**
 * Create an apollo client to query the data catalog GraphQL API
 * @param linkOptions describes how to access the data catalog GraphQL API service
 */
function apolloClientGenerator(linkOptions, xsrfToken) {
    if (linkOptions === void 0) { linkOptions = DEFAULT_LINK_OPTIONS; }
    return new apollo_client_1.default({
        link: getXSRFHeaderLink(xsrfToken).concat(apollo_link_http_1.createHttpLink(linkOptions)),
        cache: createDataCatalogInMemoryCache(),
        defaultOptions: {
            query: exports.queryOptions,
            watchQuery: exports.queryOptions,
        },
    });
}
exports.apolloClientGenerator = apolloClientGenerator;
/**
 * Creates an in-memory cache for responses from the data catalog GraphQL API
 */
function createDataCatalogInMemoryCache() {
    var fragmentMatcher = new apollo_cache_inmemory_1.IntrospectionFragmentMatcher({ introspectionQueryResultData: introspectionQueryResultData });
    return new apollo_cache_inmemory_1.InMemoryCache({ fragmentMatcher: fragmentMatcher });
}
exports.createDataCatalogInMemoryCache = createDataCatalogInMemoryCache;
//# sourceMappingURL=apolloClientGenerator.js.map